export const storageConstants = {
    brandName: 'brandName',
    bgColors: 'bgColors',
}
